
export enum CalendarSlotStatus { 
    unavailable = 0,
    available = 1,
    busy = 2,
    selected = 3
}

